import { useEffect, useMemo, useRef, useState } from 'react';
import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID, ENROLMENT_SCHEDULE_TABLE_PATH } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import ExcelUploadButtonBox from '../../../component/buttons/ExcelUploadButtonBox';
import EnrolmentStatusStudentModal from '../../modal/EnrolmentStatusStudentModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import TableBox from '../../../component/TableBox';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionEditEnrolmentValidStatusCd,
    actionExcelDownload,
    actionExcelUpload,
    actionSearch,
} from '../../../module/body/semester/SemesterStudentEnrolmentCheckViewTab1BodyModule';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { actionEditUserRegValidStatusCd } from '../../../module/body/semester/SemesterStudentUniversityModule';
import { actionEdit } from '../../../module/body/semester/SemesterStudentEnrolmentCheckViewTab1BodyModule';
import { IconButton, Tooltip } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';
import DoneIcon from '@material-ui/icons/Done';
import PauseIcon from '@material-ui/icons/Pause';

import CancelIcon from '@material-ui/icons/Close';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InputBox from '../../../component/InputBox';
import { handleControl, defaultGridData, handleGridData, initGrid } from '../../../module/component/TableBoxModule';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import PathUtil from '../../../util/PathUtil';
import qs from 'qs';
import PopupRef from '../../../component/PopupRef';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { useLocation, useNavigate } from 'react-router-dom';

const ConditionArea = ({ tabNo, popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const mainUniversityCd = AuthenticationUtil.getUserUniversityCd();
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [semesterId, setSemesterId] = useState('');
    const [userRegValidStatusCd, setUserRegValidStatusCd] = useState('');
    const [enrolmentValidStatusCd, setEnrolmentValidStatusCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.semesterId == undefined
            ? setSemesterId(SessionStorageUtil.getCurrentSemesterId())
            : setSemesterId(queryData.semesterId);
        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.userRegValidStatusCd && setUserRegValidStatusCd(queryData.userRegValidStatusCd);
        queryData.enrolmentValidStatusCd && setEnrolmentValidStatusCd(queryData.enrolmentValidStatusCd);
        queryData.userNm && setUserNm(queryData.userNm);

        onClick({
            semesterId:
                queryData.semesterId == undefined ? SessionStorageUtil.getCurrentSemesterId() : queryData.semesterId,
            mainUniversityCd,
            userUniversityCd,
            userRegValidStatusCd: queryData.userRegValidStatusCd,
            enrolmentValidStatusCd: queryData.enrolmentValidStatusCd,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClick({
            ...params,
            page,
            pageSize,
        });
    };

    const onClick = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, { ...params, tabNo });
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <EnrolmentStatusStudentModal
                row={row}
                type={modalType.EDIT}
                modalRef={modalRef}
                isUserUniversityCheck={true}
                module={actionEdit}
                callback={() => {
                    onClick(params);
                }}
            />,
            'medium',
        );
    };

    const handleUserRegValidStatusCd = (row, newValue, params) => {
        if (NullCheckUtil.isNotEmpty(newValue)) {
            dispatch(
                actionEditUserRegValidStatusCd({
                    data: {
                        userId: row.userId,
                        semesterId: row.semesterId,
                        userRegValidStatusCd: newValue,
                        force: false,
                    },
                    callback: () => {
                        onClick(params);
                    },
                }),
            );
        }
    };

    const handleEnrolmentValidStatusCd = (row, newValue, params) => {
        if (NullCheckUtil.isNotEmpty(newValue)) {
            dispatch(
                actionEditEnrolmentValidStatusCd({
                    data: {
                        semesterId: row.semesterId,
                        userId: row.userId,
                        enrolmentValidStatusCd: newValue,
                        force: false,
                    },
                    callback: () => {
                        onClick(params);
                    },
                }),
            );
        }
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const handleConfirmSchedule = (row) => {
        const path = PathUtil.pushState(ENROLMENT_SCHEDULE_TABLE_PATH, {
            userId: row.userId,
            userNm: row.userNm,
            userUniversityCd: row.userUniversityCd,
        });
        navigate(path);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClick({
                semesterId,
                userNm,
                mainUniversityCd,
                userUniversityCd,
                userRegValidStatusCd,
                enrolmentValidStatusCd,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'userUniversityNm',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'majorDeptNm',
                headerName: '전공(학과)',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'studentId',
                headerName: '소속대학 학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            {
                field: 'userRegValidStatusCd',
                headerName: '본교가입검증',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (item) => (
                    <ToggleButtonGroup
                        size='small'
                        value={item.row.userRegValidStatusCd}
                        exclusive
                        onChange={(e, newValue) => handleUserRegValidStatusCd(item.row, newValue, params)}
                    >
                        <ToggleButton
                            value='WAITING'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'WAITING')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'WAITING')}>
                                <RemoveIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='CONFIRM'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'CONFIRM')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'CONFIRM')}>
                                <DoneIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='HOLD'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'HOLD')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.USER_REG_VALID_STATUS, 'HOLD')}>
                                <PauseIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                ),
            },
            {
                field: 'enrolmentValidStatusCd',
                headerName: '본교수강자격검증',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (item) => (
                    <ToggleButtonGroup
                        size='small'
                        value={item.row.enrolmentValidStatusCd}
                        exclusive
                        onChange={(e, newValue) => handleEnrolmentValidStatusCd(item.row, newValue, params)}
                    >
                        <ToggleButton
                            value='WAITING'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'WAITING')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'WAITING')}>
                                <RemoveIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='APPROVE'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'APPROVE')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'APPROVE')}>
                                <DoneIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton
                            value='REJECT'
                            aria-label={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'REJECT')}
                            size='small'
                        >
                            <Tooltip title={CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, 'REJECT')}>
                                <CancelIcon fontSize='small' />
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 10,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='시간표확인'>
                            <IconButton onClick={(e) => handleConfirmSchedule(item.row)}>
                                <PostAddIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div className='tab-body'>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    size='medium'
                                />
                                <SelectionBox
                                    title='본교가입검증'
                                    value={userRegValidStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_REG_VALID_STATUS)}
                                    onChange={(e) => setUserRegValidStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    size='medium'
                                />
                                <SelectionBox
                                    title='본교수강자격검증'
                                    value={enrolmentValidStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_VALID_STATUS)}
                                    onChange={(e) => setEnrolmentValidStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    size='medium'
                                />
                                <InputBox
                                    title='이름'
                                    value={userNm}
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClick({
                                            semesterId,
                                            userNm,
                                            userUniversityCd,
                                            mainUniversityCd,
                                            userRegValidStatusCd,
                                            enrolmentValidStatusCd,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>본교생 수강검증 목록</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                        <ExcelUploadButtonBox
                            params={{ semesterId }}
                            callback={(e) => {
                                onClick({
                                    semesterId,
                                    userUniversityCd,
                                    mainUniversityCd,
                                    userRegValidStatusCd,
                                    enrolmentValidStatusCd,
                                    userNm,
                                    page: defaultGridData.page,
                                    pageSize: gridData.pageSize,
                                });
                            }}
                            module={actionExcelUpload}
                        />
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>해당 학기의 강의를 수강신청한 학생의 현황을 확인할 수 있습니다.</li>
                        <li>최초 가입한 학생의 경우 본인 가입 여부를 확인합니다.</li>
                        <li>
                            신청학생의 직전학기 평점 등 각 대학별 규정에 맞게 수강신청 가능 학생인지 본교 검증 후 승인
                            처리 합니다.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const SemesterStudentEnrolmentCheckViewTab1Body = ({ tabNo }) => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);
    return (
        <div>
            <ConditionArea tabNo={tabNo} popupRef={popupRef} modalRef={modalRef} />
            <TableBox />
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default SemesterStudentEnrolmentCheckViewTab1Body;
